import { useSelector } from 'react-redux';
import { getIsAccountCreationStep } from '../../flow-management/getIsAccountCreationStep';
import { getNextSteps } from '../../store/flow/selectors';
import { getFlowConfig } from '../../flow-initial/getFlowConfig';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import { getShouldShowSidePanel } from '../../utils/getShouldShowSidePanel';
import { Data } from 'signup-constants/signupData/Data';
import { useSkipStep } from '../../hooks/useSkipStep';
export const usePhoneNumberOptionalSkip = () => {
  const dataKey = Data.OptionalPhoneNumber;
  const stepKey = Step.OptionalPhoneNumber;
  const {
    handleClick
  } = useSkipStep(dataKey, stepKey);
  const {
    currentStep
  } = useCurrentStep();
  const isOptionalPhoneNumberStep = currentStep === Step.OptionalPhoneNumber;
  const isAccountCreationStep = useSelector(state => getIsAccountCreationStep(state, getNextSteps(state)));
  const shouldSkipHubletStep = getFlowConfig().shouldSkipHubletSelectionNewUser && isAccountCreationStep;
  const shouldShowSidePanel = useSelector(getShouldShowSidePanel);
  return {
    shouldSkipHublet: shouldSkipHubletStep && isOptionalPhoneNumberStep,
    shouldShowSkipButton: !shouldSkipHubletStep && !shouldShowSidePanel && isOptionalPhoneNumberStep,
    shouldShowSkipButtonInSidePanel: !shouldSkipHubletStep && shouldShowSidePanel && isOptionalPhoneNumberStep,
    handleClickSkip: handleClick,
    dataKey,
    stepKey
  };
};